"use client";

import { Skeleton } from "antd";
import { UseCaseCardSkeleton } from "@/components/skeletons/UseCaseCardSkeleton";

export default function UseCaseListPageSkeleton() {
  return (
    <div className="relative flex flex-col justify-center items-center mt-6 mx-2 sm:mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150] z-10">
      {/* Hero Section Skeleton */}
      <div className="relative flex flex-col justify-center items-center text-center xl:h-screen max-w-[2000px] z-50 mt-16 xl:mt-0 lg:mt-20 w-full">
        {/* Heading Skeleton */}
        <div className="mb-5 w-[200px] h-[70px] mobile:w-[300px] mobile:h-[120px] sm:w-[400px] sm:h-[150px] md:w-[500px] md:h-[180px] lg:w-[600px] lg:h-[210px] xl:w-[700px] xl:h-[230px] 3xl:w-[800px] 3xl:h-[290px]">
          <Skeleton.Input active style={{ width: "100%", height: "100%" }} />
        </div>

        {/* Subheading Skeleton */}
        <div className="mb-8 w-[250px] h-[12px] md:w-[300px] md:h-[14px] lg:w-[350px] lg:h-[16px] xl:w-[400px] xl:h-[20px]">
          <Skeleton.Input active style={{ width: "100%", height: "100%" }} />
        </div>

        {/* Paragraph Skeleton */}
        <div className="w-full max-w-[1090px] 3xl:max-w-[1400px] mt-4 xl:mt-[54px]">
          <Skeleton
            active
            paragraph={{ rows: 2, width: ["100%", "90%"] }}
            title={false}
          />
        </div>
      </div>

      {/* Grid of cards skeleton */}
      <div className="mt-16 w-full">
        <div className="grid grid-cols-1 mobile:grid-cols-2 md:grid-cols-3 tablet:grid-cols-3 gap-4 mobile:gap-3 sm:gap-4 md:gap-3 tablet:gap-6 lg:gap-10 2xl:gap-20 3xl:gap-30 max-w-[1800px] mx-auto">
          {Array.from({ length: 6 }).map((_, i) => (
            <UseCaseCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
